<template>
<div class="plant">
  <mini-banner
   urlPicture='/images/banners/industry/crop.jpg'
   urlVector='/images/banners/grafic.svg'
     urlIcon='/svg/industry/flower.svg'>
     РАСТЕНИЕВОДСТВО
    </mini-banner>

  <bread-crambs  class="breadcrumbs-bg" />

  <white-title>
    {{ whiteTitle }}
  </white-title>

  <div class="plant__content">
    <only-text
   onlyText="РАСТЕНИЕВОДСТВО – ЭТО НАУКА О КУЛЬТУРНЫХ
   РАСТЕНИЯХ И МЕТОДАХ ИХ ВЫРАЩИВАНИЯ С ЦЕЛЬЮ ПОЛУЧЕНИЯ ВЫСОКИХ УРОЖАЕВ НАИЛУЧШЕГО
    КАЧЕСТВА С НАИМЕНЬШИМИ ЗАТРАТАМИ ТРУДА И СРЕДСТВ (ЧАСТНОЕ ЗЕМЛЕДЕЛИЕ)." />

  <dash-text class="dash-text_blue">
       Основным объектом исследования Растениеводства как науки
   является с/х растение (вид, разновидность, сорт, гибрид), его биология,
    требования к окружающей среде — агроэкологическим условиям. Число видов
     с/х растений, возделываемых на земном шаре, превышает 20 тыс. Наиболее
      важное значение имеют лишь 640 видов, из которых около 90 относится к
       полевой культуре. Для примера приведём сортовое разнообразие основного
        продовольственного продукта нашей планеты – риса: данный злак представлен
         20 ботаническими видами и 150 разновидностями, всего насчитывается более
          8 000 агросортов.
  </dash-text>

  </div>

  <border-pic-list class="description__title_blue check-list__item_full-width"
    :picContent="picContent"
    :description="estimates"
    :descTitle="descTitle" />

  <only-text onlyText="РАЗРАБАТЫВАЕМАЯ СИСТЕМА CLASS НА ДАННОМ ЭТАПЕ РАЗВИТИЯ ОРИЕНТИРОВАНА
   В ПЕРВУЮ ОЧЕРЕДЬ НА ПОЛЕВЫЕ КУЛЬТУРЫ, А В ПЕРСПЕКТИВЕ НА ПЛОДООВОЩНЫЕ." />

  <border-pic-list
   :picContent="picContentService"
   :description="servicesItem"
   @showModal="showModalPic(picContentService)"
    class="reverse border-pic_gray description__title_blue check-list__item_full-width"
    :descTitleShow="descTitleShow" />

  <crop-groups/>

  <white-title class="bottom">
  {{ servisesTitle }}
  </white-title>

  <crop-servises>
    <button class="plant__button"
      @click="showModalWindow(index)"
      v-for="cropImage, index in cropImages" :key="cropImage"
      :class="`plant__image-${index}`" >
      <div class="plant__image"
      >
        <img class="plant__image-pic" alt="plant"
        :src="cropImage">
      </div>
    </button>
  </crop-servises>

  <right-product-bg />

  <left-product-bg />

  <modal-mask class="modal__screens"
    :showModal="showModal" @closeModal="showModal = false, showModalSlider = false"
    :class="[ showModalSlider ? 'gallery__modal' : 'modal__screens']">

      <main-slider  v-if="showModalSlider" :slides="cropImages" controls dots :page="page"
      :currentSlides="currentSlides"/>

      <div class="modal__img" v-else>
        <img class="modal__img-pic" alt="modal-screen"
        :src="activePic">
      </div>
  </modal-mask>

</div>
</template>

<script>
import MiniBanner from '@/components/shared/MiniBanner.vue';
import BreadCrambs from '@/components/shared/BreadCrambs.vue';
import BorderPicList from '@/components/shared/listing/BorderPicList.vue';
import DashText from '@/components/shared/DashText.vue';
import LeftProductBg from '@/components/shared/background/LeftProductBg.vue';
import OnlyText from '@/components/shared/OnlyText.vue';
import WhiteTitle from '@/components/shared/WhiteTitle.vue';
import CropServises from '@/components/industry/CropServises.vue';
import CropGroups from '@/components/industry/CropGroups.vue';
import RightProductBg from '@/components/shared/background/RightProductBg.vue';
import ModalMask from '@/components/shared/ModalMask.vue';
import MainSlider from '@/components/shared/sliders/MainSlider.vue';

export default {
  data() {
    return {
      activePic: '',
      showModal: false,
      showModalSlider: false,

      descTitleShow: false,

      whiteTitle: 'ХАРАКТЕРИСТИКИ ОТРАСЛИ',
      servisesTitle: 'ПРЕДЛАГАЕМЫЕ УСЛУГИ',
      descTitle: 'Растениеводство изучает:',
      estimates: [{
        text: 'продолжительность вегетационного периода сельскохозяйственных растений',
      },
      {
        text: 'ритмы роста и развития',
      },
      {
        text: 'последовательные фазы вегетации и морфогенеза',
      },
      {
        text: 'динамику развития корневой системы и ассимиляционной поверхности, накопления сухого вещества, формирования хозяйственно-полезных органов и частей растения',
      },
      {
        text: 'обмен веществ',
      },
      {
        text: 'водный и пищевой режимы',
      },
      {
        text: 'зимостойкость, морозостойкость, засухоустойчивость, солеустойчивость и др.',
      },
      ],
      picContent: {
        pic: '/images/industry/crop/flower.jpg',
      },
      servicesItem: [{
        text: 'Рассматриваемая предметная область очень сложна, т.к. степень сложности такого простого объекта как растение во взаимодействии с окружающей средой невозможно ни оценить, ни преуменьшить. Не будет сильным преувеличением сказать, что каждая характеристика состояния посева влияет на динамику любой другой его части. ',
      },
      {
        text: 'Понимание и обобщение сотен тысяч молекулярных процессов, происходящих одновременно в растении, делают тщетными попытки полного описания его физиологических характеристик. Кроме того, каждый вегетационный период, каждый регион, каждое поле, каждый участок представляют собой новую среду, где взаимодействие многих факторов определяет урожай на единицу площади.  ',
      },
      ],
      picContentService: {
        pic: '/images/industry/crop/matrix.jpg',
        isLink: true,
      },

      currentSlides: 0,
      page: 'gallery',

      cropImages: ['/images/industry/crop/crop1.jpg', '/images/industry/crop/crop2.jpg', '/images/industry/crop/crop3.jpg'],

    };
  },
  emits: ['closeModal', 'showModal'],
  components: {
    MiniBanner,
    BreadCrambs,
    DashText,
    LeftProductBg,
    OnlyText,
    WhiteTitle,
    BorderPicList,
    CropServises,
    CropGroups,
    RightProductBg,
    ModalMask,
    MainSlider,
  },
  methods: {
    showModalPic(atr) {
      this.activePic = atr.pic;
      this.showModal = true;
    },
    showModalWindow(index) {
      this.showModalSlider = true;
      this.currentSlides = index;
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/src/assets/css/modal.scss";

$light-gray: #D5D6D7;
$blue: #4DB6BC;

.plant {
  position: relative;
  color: $light-gray;

  &__content {
    max-width: 90%;
    margin: 30px 0 0;

    @media (max-width: 910px) {
      max-width: 100%;
    }
  }
    &__button {
    border: #555A60 solid;
    max-width: 400px;
    cursor: pointer;
    background: transparent;
  }
  &__image {
  height: 100%;
    &-pic {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    &-0 {
      grid-area: c;
      border-radius: 12px 0 0 12px;
      border-width: 30px 15px 30px 30px;
      @media (max-width: 720px) {
        border-width: 25px;
        border-radius: 12px;
      }
    }
    &-1 {
      grid-area: d;
      border-radius: 0;
      border-width: 30px 15px 30px;
      @media (max-width: 720px) {
        border-width: 25px;
        border-radius: 12px;
      }
    }
    &-2 {
      grid-area: e;
      border-radius: 0 12px 12px 0;
      border-width: 30px 30px 30px 15px;
      @media (max-width: 720px) {
        border-width: 25px;
        border-radius: 12px;
      }
    }
  }
}
</style>
